<template>
  <div id="companies-container">
    <div v-if="agentSelectionAuctions.length > 0">
      <h3 style="font-size: 16px;" class="newaslp">
        {{ appealingText }}の<br /><span>非公開求人</span>が多い転職支援会社
      </h3>
      <error-message item-name="agent_selection_auction_ids" />
      <agent-selection-auction-ids-form
        required
        :agentSelectionAuctions="featuredAuctions"
      />

      <div class="text-right m3p_clearboth">
        <a
          v-show="additionalAuctions.length > 0"
          id="collapseOtherCompanies"
          @click="toggleCollapsedButton"
          title="支援会社をすべて表示"
          class=" m3p_mr10"
          style="cursor: pointer"
        >
          <span class="glyphicon glyphicon-chevron-down"></span
          >&nbsp;支援会社をすべて表示
        </a>
      </div>
      <div
        v-show="additionalAuctions.length > 0 && collapseButtonOpened"
        class="clearfix m3p_pb10"
      >
        <agent-selection-auction-ids-form
          required
          :agentSelectionAuctions="additionalAuctions"
        />
      </div>
    </div>
    <div v-else>
      <h3 style="font-size: 16px;" class="newaslp">
        上記からご希望のエリア・雇用形態・業種を選択してください
      </h3>
      <div class="agent_selection_blur">
        <img
          :src="
            require(`@assets/images/pc/original/agent-selection/secret/as_mv_conmany_blur.jpg`)
          "
          alt="ご希望のエリア・雇用形態・業種に合わせて、おすすめの支援会社を表示します"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, ref, watch } from "vue";
import { useStore } from "vuex";
import shuffle from "lodash/shuffle";
import AgentSelectionAuctionIdsForm from "@component_path/pages/pc/agent_selection/secret/components/form_item/AgentSelectionAuctionIds/Checkbox";
import ErrorMessage from "@component_path/pages/pc/agent_selection/secret/components/form_item/ErrorMessage";
import { useAuctionCompaniesStore } from "@component_path/inquiry_form_common_module/custom_hook/AuctionCompanies";
import { useEmploymentTypeStore } from "@component_path/agent_selection_wish_module/custom_hook/EmploymentType";
import { usePositionTypeStore } from "@component_path/agent_selection_wish_module/custom_hook/PositionType";
import { usePrefectureIdStore } from "@component_path/inquiry_form_common_module/custom_hook/PrefectureId";
import { useAddressStore } from "@component_path/agent_selection_wish_module/custom_hook/Address";

const store = useStore();

const MAX_FEATURED_AGENT_SELECTION_COMPANIES_COUNT = 3;

const collapseButtonOpened = ref(false);

const { agentSelectionAuctions } = useAuctionCompaniesStore();
const { employmentTypeText } = useEmploymentTypeStore();
const { addressText } = useAddressStore();
const { positionTypeText } = usePositionTypeStore();
const { prefectureText } = usePrefectureIdStore();

const toggleCollapsedButton = () =>
  (collapseButtonOpened.value = !collapseButtonOpened.value);

const appealingText = computed(() => {
  return `${
    prefectureText.value
      ? `「${prefectureText.value}${addressText.value}」`
      : ""
  }${employmentTypeText.value}${positionTypeText.value}`;
});

const featuredAuctions = computed(() =>
  shuffle(
    store.getters["masterData/featuredAgentSelectionAuctions"](
      MAX_FEATURED_AGENT_SELECTION_COMPANIES_COUNT
    )
  )
);

const additionalAuctions = computed(() =>
  shuffle(
    store.getters["masterData/additionalAgentSelectionAuctions"](
      MAX_FEATURED_AGENT_SELECTION_COMPANIES_COUNT
    )
  )
);

watch(employmentTypeText, () => {
  store.dispatch("fetchCompanies", {
    lpType: "secret",
    defaultSelectCount: MAX_FEATURED_AGENT_SELECTION_COMPANIES_COUNT
  });
});

watch(positionTypeText, () => {
  store.dispatch("fetchCompanies", {
    lpType: "secret",
    defaultSelectCount: MAX_FEATURED_AGENT_SELECTION_COMPANIES_COUNT
  });
});

watch(prefectureText, () => {
  store.dispatch("fetchCompanies", {
    lpType: "secret",
    defaultSelectCount: MAX_FEATURED_AGENT_SELECTION_COMPANIES_COUNT
  });
});

watch(agentSelectionAuctions, () => {
  collapseButtonOpened.value = false;
});
</script>
